import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import PanelLayout from '@/components/PanelLayout.vue';
import RezTabFile from '@/store/modules/RezTabFile';
import { ref, watch } from 'vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const fileInput = ref();

function getTheFile(e: Event) {
    const file = fileInput.value.files[0]
    if (!file) return;
    const fileReader = new FileReader();
    fileReader.addEventListener('loadend', e => {
        const doc = RezTabFile.instanceFromXmlString(e.target?.result as string)
        
    })
    fileReader.readAsText(file)
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PanelLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _cache[0] || (_cache[0] = _createElementVNode("h1", { class: "va-h3" }, " Importer ", -1)),
        _cache[1] || (_cache[1] = _createTextVNode(" You can choose your .mei file here: ", -1)),
        _createElementVNode("input", {
          type: "file",
          onChange: getTheFile,
          ref_key: "fileInput",
          ref: fileInput
        }, null, 544)
      ])
    ]),
    _: 1
  }))
}
}

})